import { anonymousRequests, adminRequests } from 'api/request';
import urls from 'configs/urls';

export const getStaticData = ({ data }) =>
  adminRequests.get(null, false, urls.commonUrls.getStaticData, data);

export const getCompanyProfiles = ({ data }) =>
  adminRequests.get(null, false, urls.commonUrls.getCompanyProfiles, data);

export const getPreSignedUrl = ({ headers, data }) =>
  adminRequests.get(headers, false, urls.commonUrls.getPreSignedUrl, data);

export const readPreSignedUrl = ({ headers, data }) =>
  adminRequests.get(headers, false, urls.commonUrls.readPreSignedUrl, data);

export const uploadFiles = ({ headers, url, data }) =>
  anonymousRequests.put(headers, false, url, data);
